//qv scripts
$(document).on("click", ".js-open-qv", function (e) {
  e.preventDefault();
  e.stopPropagation();
  var $qv = $(".product-qv-drawer-wrapper");
  var handle = $(this).data("handle");
  $.ajax({
    type: "GET",
    url: window.Shopify.routes.root + "products/" + handle + "?view=qv",
    success: function (html) {
      console.log(html);
      var new_qv_content = $(html).find(".product-qv-content-container");
      console.log(new_qv_content);
      $qv.find(".product-qv-content-wrapper").html(new_qv_content);
      $("html, body").addClass("qv--open");
      $qv.addClass("open");
    },
    error: function () {
      window.location.href = $(this).attr("href");
    },
  });
});

$(document).on("click", ".product-qv-close, .qv-add-to-cart", function (e) {
  qvClose();
});

// Close qv on body click
$(document).on("click", function (e) {
  if (
    !$(e.target).is(".product-qv-container *") &&
    $("html").hasClass("qv--open")
  ) {
    qvClose();
  }
});

function qvClose() {
  var $qv = $(".product-qv-drawer-wrapper");

  var delay = 400;
  $qv.addClass("closing");
  setTimeout(function () {
    $qv.removeClass("open");
    $qv.removeClass("closing");
  }, delay);

  $("html, body").removeClass("qv--open");
}


/* IMPLEMENT VARIANT HANDLING */